module.exports = [
	{
		"id": 1,
		"stage": 0,
		"title": "Our church has a clear mission (purpose) that everyone on the team is rallied around."
	},
	{
		"id": 2,
		"stage": 0,
		"title": "Our primary ministry focus is reaching new people, even though we know we need to pay attention to other ministry priorities in the future."
	},
	{
		"id": 3,
		"stage": 0,
		"title": "With very few staff right now, we depend and survive on high volunteer engagement."
	},
	{
		"id": 4,
		"stage": 0,
		"title": "Our church focuses its energies and resources primarily on the weekend service, whether online or in-person (i.e., teaching, worship, children’s ministry and guest services)."
	},
	{
		"id": 5,
		"stage": 0,
		"title": "Our church finances are tight and limited."
	},
	{
		"id": 6,
		"stage": 0,
		"title": "Our church has very few, if any, rules (policies and systems)."
	},
	{
		"id": 7,
		"stage": 0,
		"title": "Our church gravitates towards an exciting and hopeful future."
	},
	{
		"id": 8,
		"stage": 1,
		"title": "Our church has an outward focus removing whatever barriers necessary to reach people outside the church and the faith."
	},
	{
		"id": 9,
		"stage": 1,
		"title": "Our church has a “come and see” buzz in our community due to our congregation inviting new people to come to our church."
	},
	{
		"id": 10,
		"stage": 1,
		"title": "Our church is characterized by creativity and innovation (i.e. out-of-the-box-thinking approach to ministry)."
	},
	{
		"id": 11,
		"stage": 1,
		"title": "Our church has identified a specific vision for future direction marked by specific goals and benchmarks."
	},
	{
		"id": 12,
		"stage": 1,
		"title": "Our senior pastor is namely the driving personality or face for our church ministry."
	},
	{
		"id": 13,
		"stage": 1,
		"title": "Creating ministry teams and giving leadership away is something we’re just starting to do."
	},
	{
		"id": 14,
		"stage": 1,
		"title": "For the first time, our numerical growth is starting to generate financial growth."
	},
	{
		"id": 15,
		"stage": 2,
		"title": "Our leadership is shifting from a few visible leaders to a team-based approach that defines clear roles and responsibilities for staff and high-level volunteers."
	},
	{
		"id": 16,
		"stage": 2,
		"title": "Due to continued growth, we’re recognizing the need for more defined systems to connect people to one another and help them take their next steps to engage in the church."
	},
	{
		"id": 17,
		"stage": 2,
		"title": "Our growth is necessitating that we establish systems to keep everyone aligned."
	},
	{
		"id": 18,
		"stage": 2,
		"title": "Our church is beginning to recognize that healthy change is expected and needs to be a part of our culture."
	},
	{
		"id": 19,
		"stage": 2,
		"title": "Regarding our structure, we are shifting from an “all hands on deck” approach, to a more formal leadership structure. This forming structure addresses our volunteers, volunteer ministry leaders, staff leaders and our church governance."
	},
	{
		"id": 20,
		"stage": 2,
		"title": "Our decision making process empowers our leaders to release decision making to more people."
	},
	{
		"id": 21,
		"stage": 2,
		"title": "For the first time, our church has begun to build financial and giving systems to fund ministry and expand vision."
	},
	{
		"id": 22,
		"stage": 3,
		"title": "Our church is reproducing and multiplying at all levels and in all areas of ministry."
	},
	{
		"id": 23,
		"stage": 3,
		"title": "Our church has a collaborative culture where people are coordinating, contributing and cooperating in a spirit of unity."
	},
	{
		"id": 24,
		"stage": 3,
		"title": "Our church has a healthy balance between refreshed vision and healthy systems and structures to support the vision."
	},
	{
		"id": 25,
		"stage": 3,
		"title": "Our church is intentional about developing leadership through an effective leadership development process."
	},
	{
		"id": 26,
		"stage": 3,
		"title": "Our church ministry programming is reproduced through multiple church services or/and locations."
	},
	{
		"id": 27,
		"stage": 3,
		"title": "Our church is intentional about structuring & staffing around plans related to our reach strategies (strategies that reach people currently outside the faith/church ). This includes things like weekend services, multisite locations and/or church planting."
	},
	{
		"id": 28,
		"stage": 3,
		"title": "Our church has a stewardship and generosity culture in place contributing to the reproduction and expansion of ministry."
	},
	{
		"id": 29,
		"stage": 4,
		"title": "Our church is concerned about keeping our church family happy and content (i.e. we are insider-focused)."
	},
	{
		"id": 30,
		"stage": 4,
		"title": "The number of people engaged with our church, whether through attendance or otherwise, has plateaued or is beginning to decline."
	},
	{
		"id": 31,
		"stage": 4,
		"title": "Our church is over-programmed, with many competing priorities filling the ministry calendar."
	},
	{
		"id": 32,
		"stage": 4,
		"title": "Our vision has staled. We might have one, but it isn’t rallying our team towards a specific destination anymore."
	},
	{
		"id": 33,
		"stage": 4,
		"title": "Although growth has slowed, finances have remained strong."
	},
	{
		"id": 34,
		"stage": 4,
		"title": "We typically hire a staff person, rather than call on a volunteer leader, when we encounter an opportunity or challenge."
	},
	{
		"id": 35,
		"stage": 4,
		"title": "Our church has established traditions that are being protected through controlling attitudes."
	},
	{
		"id": 36,
		"stage": 5,
		"title": "If we’re honest, we do/don’t do things in order to keep people from leaving the church."
	},
	{
		"id": 37,
		"stage": 5,
		"title": "Our church wants to return to the “good-old-days”, unwilling to innovate and change."
	},
	{
		"id": 38,
		"stage": 5,
		"title": "Our church ministries jockey to preserve their turf even as the church declines creating ministry silos and turf wars."
	},
	{
		"id": 39,
		"stage": 5,
		"title": "A lot of our church’s leadership and decision-making is happening by the lay leadership board."
	},
	{
		"id": 40,
		"stage": 5,
		"title": "Our church culture has become bureaucratic (“what do the bylaws and constitution say?”)"
	},
	{
		"id": 41,
		"stage": 5,
		"title": "Our church finances are declining causing staff reductions and/or ministry cutbacks."
	},
	{
		"id": 42,
		"stage": 5,
		"title": "Our church leaders blame other churches for the loss of people. "
	},
	{
		"id": 43,
		"stage": 6,
		"title": "Our church is bleeding both people and finances creating a culture of crisis.  "
	},
	{
		"id": 44,
		"stage": 6,
		"title": "Our church is led by a key family or donor."
	},
	{
		"id": 45,
		"stage": 6,
		"title": "Our church systems and structures are broken and dysfunctional."
	},
	{
		"id": 46,
		"stage": 6,
		"title": "Our church paid positions are being eliminated with declining team morale."
	},
	{
		"id": 47,
		"stage": 6,
		"title": "Our church is attempting to reach new people with old and antiquated methods."
	},
	{
		"id": 48,
		"stage": 6,
		"title": "Our church is focused on keeping the doors open without facing reality and making the necessary changes."
	},
	{
		"id": 49,
		"stage": 6,
		"title": "Our church is experiencing no conversion growth."
	},
	{
		"id": 50,
		"stage": null,
		"title": "I'm encouraged by the number of people who have crossed the line of faith through the ministries of our church in the last year."
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/assess/question/questions_opinion.json
// module id = 429
// module chunks = 0